import { render, staticRenderFns } from "./AccountSettingGeneral.vue?vue&type=template&id=586b045a&scoped=true&"
import script from "./AccountSettingGeneral.vue?vue&type=script&lang=js&"
export * from "./AccountSettingGeneral.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingGeneral.vue?vue&type=style&index=0&id=586b045a&scoped=true&lang=scss&"
import style1 from "./AccountSettingGeneral.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586b045a",
  null
  
)

export default component.exports